import socket from './socket';
import http from './http';
import { transformUser } from './users';
import { transformBoardMembership } from './board-memberships';
import { transformCard } from './cards';
import { transformAttachment } from './attachments';

/* Actions */

const createBoard = (projectId, data, headers) =>
  socket.post(`/projects/${projectId}/boards`, data, headers).then((body) => ({
    ...body,
    included: {
      ...body.included,
      boardMemberships: body.included.boardMemberships.map(transformBoardMembership),
    },
  }));

const createBoardWithImport = (projectId, data, requestId, headers) =>
  http.post(`/projects/${projectId}/boards?requestId=${requestId}`, data, headers);

const getBoard = (id, subscribe, headers) =>
  socket
    .get(`/boards/${id}${subscribe ? '?subscribe=true' : ''}`, undefined, headers)
    .then((body) => {
      if (!body || !body.item || !body.included) {
        const error = new Error('Invalid board response');
        error.body = body;
        throw error;
      }

      const { included } = body;

      return {
        ...body,
        included: {
          ...included,
          users: (included.users || []).map(transformUser),
          boardMemberships: (included.boardMemberships || []).map(transformBoardMembership),
          cards: (included.cards || []).map(transformCard),
          attachments: (included.attachments || []).map(transformAttachment),
        },
      };
    });

const updateBoard = (id, data, headers) => socket.patch(`/boards/${id}`, data, headers);

const archiveBoard = (id, headers) => socket.patch(`/boards/${id}`, {is_archive:  true}, headers);

const restoreBoard = (id, headers) => socket.patch(`/boards/${id}`, {is_archive:  false}, headers);

const deleteBoard = (id, headers) => socket.delete(`/boards/${id}`, undefined, headers);

export default {
  createBoard,
  createBoardWithImport,
  getBoard,
  archiveBoard,
  updateBoard,
  deleteBoard,
  restoreBoard,
};
